module.exports = __webpack_public_path__ + "img/category.373d80c5.png";